import {
  useBoltApiClient,
  IBoltTaskTemplate,
  INewBoltTaskTemplate,
} from "@bolt/core";
import { SchemaFactoryV2, useFieldSchemaV2 } from "@ucl/library";
import { useState, useRef, useEffect } from "react";
import { BoltTaskTemplateFormProps } from "./builders/CreateBoltTaskTemplateFormContainer";
import { defaultTaskTemplate } from "./CreateTaskTemplateForm";

export const useTaskTemplateForm = ({
  taskTemplates,
  updateTaskTemplates,
  workflowType,
}: Pick<
  BoltTaskTemplateFormProps,
  "taskTemplates" | "updateTaskTemplates" | "workflowType"
>) => {
  const boltApiClient = useBoltApiClient();
  const [schemaFactory, setSchemaFactory] = useState<SchemaFactoryV2>();

  const { getAsyncSchemaFactory } = useFieldSchemaV2("tasks/field-schema");
  const loadingRef = useRef<boolean>(false);

  const getSchema = async () => {
    if (loadingRef.current) {
      return;
    }

    loadingRef.current = true;
    setSchemaFactory(await getAsyncSchemaFactory(boltApiClient));
  };

  useEffect(() => {
    if (loadingRef.current) {
      loadingRef.current = false;
    }
  }, [schemaFactory]);

  useEffect(() => {
    getSchema();

    if (taskTemplates.length === 0) {
      const defaultTaskTemplateValue = {
        ...defaultTaskTemplate,
        hasMultiSteps: workflowType === "Multi-Step",
      };
      updateTaskTemplates([defaultTaskTemplateValue]);
    } else if (workflowType && taskTemplates.length > 0) {
      // For each step, update the task type with the workflow type
      const updatedTaskTemplates = taskTemplates.map((taskTemplate) => ({
        ...taskTemplate,
        hasMultiSteps: workflowType === "Multi-Step",
      }));
      updateTaskTemplates(updatedTaskTemplates);
    }
  }, []);

  const updateParentTaskTemplate = (
    taskTemplateToUpdate: IBoltTaskTemplate | INewBoltTaskTemplate
  ) => {
    updateTaskTemplates(
      taskTemplates.map((ogTT) =>
        ogTT.orderNumber === 0 ? { ...ogTT, ...taskTemplateToUpdate } : ogTT
      )
    );
  };
  const parentTaskTemplate = taskTemplates[0];

  return {
    parentTaskTemplate,
    schemaFactory,
    updateParentTaskTemplate,
  };
};
